import initModal from './initializers/Modal.js'
import initUser from './initializers/User.js'

const initApplication = () => {
  initModal()
  initUser()
}

export default initApplication
